/* 🤖 this file was generated by svg-to-ts */
export const siriusCheck: {
  name: 'check';
  data: string;
} = {
  name: 'check',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.78 6.22a.75.75 0 0 1 0 1.06l-10.5 10.5a.75.75 0 0 1-1.06 0l-5.25-5.25a.75.75 0 1 1 1.06-1.06l4.72 4.72 9.97-9.97a.75.75 0 0 1 1.06 0Z" fill="currentColor"/></svg>`
};
